import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";

import { Province } from '../models/province.model';
import { ResponseModel } from '../models/response.model';
import { BaseModel } from '../models/base.model';
import { GeneralService } from './general.service';
import { environment } from '../../environments/environment';
import { PersistenceService } from 'angular-persistence';
import { HttpParams } from '@angular/common/http';
import { SelectItem } from 'primeng/primeng';
import { SelectModel } from '../models/select.model';

@Injectable()
export class ProvinceService extends GeneralService {
  constructor(protected httpClient: HttpClient, protected persistenceService: PersistenceService) {
    super(httpClient, persistenceService, environment.apiGeneralUrl, "province");
  }

  getProvinceByName(name: string, countryId: number = null) {
    let params = new HttpParams();
    params = params.append("name", name);

    if(countryId) {
      params = params.append("countryId", countryId.toString());
    }

    return super.getCustomApi("getProvinceByName", params);
  }
  
  async getAllSelectModelAsync(): Promise<SelectModel[]> {
    const res = await this.getAll().toPromise();
    if (res.isSuccess) {
      const data = res.data as Province[];
      if (data) {
        const province: SelectModel[] = [];
        province.push({ label: `-- Chọn tỉnh/thành --`, value: null });
        data.forEach(element => {
          province.push({
            label: `${element.code} - ${element.name}`,
            value: element.id,
            data: element
          });
        });
        return province;
      }
    }
    return null;
  }

  public async getSelectModelAllNewAsync(): Promise<SelectModel[]> {
    const res = await this.getAllNewAsync();
    const data: SelectModel[] = [];
    data.push({ label: "-- Chọn tỉnh thành --", value: null });
    if (res) {
      res.forEach(element => {
        data.push({ label: `${element.code} - ${element.name}`, value: element.id, data: element });
      });
      return data;
    } else {
      return null;
    }
  }

  public async getAllNewAsync(arrCols: string[] = [], pageSize: number = undefined, pageNumber: number = undefined): Promise<any> {
    const res = await this.getAllNew(arrCols, pageSize, pageNumber).toPromise();
    if (res.isSuccess) {
      let data = res.data as any;
      return data;
    }
    return null;
  }
}



// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/services/province.service.ts